/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { Tabs } from 'antd-mobile'
import { observer } from 'mobx-react'
// css
import { TabTxt, UnderLineTabWrap } from '@styles/base.style'
import { Models } from 'rmc-tabs/lib/Models'
import { PROPERTY_ID } from 'adv-protocol/src/GameCommon'
import useRootStore from '@store/useRootStore'
import { useOnMount, useOnUnmount } from '@utils/reactExt'

const tabs: Models.TabData[] = [
  {
    title: <TabTxt>G머니</TabTxt>,
    propertyId: PROPERTY_ID.MONEY,
  },
  {
    title: <TabTxt>하트</TabTxt>,
    propertyId: PROPERTY_ID.HEART,
  },
  {
    title: <TabTxt>S캐시</TabTxt>,
    propertyId: PROPERTY_ID.CASH,
  },
]
const MoneyHistoryTab: React.FC = () => {
  const { bankStore } = useRootStore()
  const { currentMyBankTabIndex, setSelectedMyBankTab } = bankStore

  useOnMount(() => {
    setSelectedMyBankTab(0, PROPERTY_ID.MONEY)
  })

  useOnUnmount(() => {
    setSelectedMyBankTab(0, null)
  })

  const tabChanged = (tab: Models.TabData, tabIndex: number) => {
    setSelectedMyBankTab(tabIndex, tab.propertyId)
  }

  return (
    <UnderLineTabWrap className="black-line">
      <Tabs tabs={tabs} initialPage={currentMyBankTabIndex} page={currentMyBankTabIndex} onChange={tabChanged}/>
    </UnderLineTabWrap>
  )
}

export default observer(MoneyHistoryTab)
